(function() {
	
	var AddToQuote = function() {
		this.init();
	};

	AddToQuote.prototype = {

		init: function() {
			$('.add-to-quote').on('submit', function(e) {
				let addToCartForm = $(this).closest('.add-to-links').siblings('.product-add-to-cart')
				let quantity = addToCartForm.find('.quantity').val();
				$(this).find('.add-to-quote-quantity').val(quantity)

				// The addToCart form's product id updates dynamically for config products, so copy it if it's present
				let addToCartProductId = addToCartForm.find('#product_id').val()
				if (addToCartProductId) {
					$(this).find('input[name="product_id"]').val(addToCartProductId)
				}
			});
		}
		
	};

	C.AddToQuote = AddToQuote;
	
})();